import { isRouteAuthorized as isAuthorized } from '../security/isRouteAuthorized';
import { showAccessDeniedToast } from '../security/showAccessDeniedToast';

export default function requireAuthAndAuthz(store) {
    return function(nextState, replace, callback) {
        const { session } = store.getState();
        const isAuthenticated = !!session.user;

        const { pathname, search } = nextState.location;

        let redirectTo = pathname;

        if (search) {
            redirectTo += search;
        }
        if (!isAuthenticated) {
            replace({
                pathname: '/login',
                query: redirectTo ? { redirectTo } : {},
            });
        }

        if (isAuthenticated && !isAuthorized(session.user, redirectTo)) {
            showAccessDeniedToast();
        } else {
            callback();
        }
    };
}
